import React from 'react';
import BasePage from './BasePage';
import axios from 'axios';

import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row, Table,} from 'reactstrap';
import userProfilePicture from 'assets/img/users/user_pp.png';
import Page from '../components/Page';
import ItemOption from '../components/Widget/ItemOption';
import Global, {DD_MM_YYYY_HH_MM_SS, USER_STATUSES,} from '../utils/Global';
import {
    allIsEmpty,
    cleanPhoneNumber,
    deleteParam,
    imageSelector,
    isEmpty,
    isValidEmail,
    parseDate,
} from '../utils/Utilities';
import queryString from 'query-string';
import FormText from 'reactstrap/es/FormText';
import SearchInput from '../components/SearchInput';
import {UserDto} from '../model/model.ts';
import DateInput from '../components/Widget/DateInput';
import ImageCropper from '../components/modal/ImageCropper';
import {MdDelete, MdHistory, MdSave, MdSecurity} from 'react-icons/md';
import UpdateUserStatusModal from '../components/modal/UpdateUserStatusModal';
import label, {GENDERS} from 'enqc-utilities/src/label/Label'

import kitchen from "../utils/AxiosInstance";
import WarningLabel from "../components/Widget/WarningLabel";
import UserStatusHistoryModal from "../components/modal/UserStatusHistoryModal";
import MyCardImage from "../components/Card/MyCardImage";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import Endpoint from "enqc-utilities/src/api/Endpoint";

class UserDetailPage extends BasePage{

    user = new UserDto()

    constructor(props) {
        super(props);
        this.state = {
            phoneNumberWarning:"",
            user:this.user,
            photoBlob:null,
            image:null,
            userIdQuery: queryString.parse(this.props.query).id,
            gender:{},
            userStatus:{},
            ascending:false,
            sortir:'created',
            userRoles:[],
            userRole:{},
            manufacturingSites:[],
            manufacturingSite:{},
            banks:[],
            bank:{},
            provinces:[],
            cities:[],
            districts:[],
            villages:[],
            province:{},
            city:{},
            district:{},
            village:{},
            transactionStatuses:[],
            transactions:[],
            transactionStatus:null,
            refCode:"",
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            updateUserStatusModal:false,
            userStatusModal:false,
            deviceSortir:"ud.created",
            deviceSearch:"",
            deviceAscending:false,
        }
        this.fetchProvinces((provinces)=>this.setState({provinces:provinces}))
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchUserDetail(this.state.userIdQuery)
        this.fetchBanks()
        this.fetchAllRole()
        this.fetchManufacturingSites()
    }

    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            this.setState({
                page:queryString.parse(props.query).page?queryString.parse(props.query).page:1,
                userIdQuery: queryString.parse(props.query).id,
            }, () => {
                this.fetchUserDetail(this.state.userIdQuery)
            })
        }
    }


    confirmSave = async () =>{
        let {user, userRole, manufacturingSite} = this.state
        let valid = true ;

        if(isEmpty(user.firstname) || user.firstname.length<3){
            this.setState({
                fistNameWarning:label.PleaseEnterFirstName
            })
            valid = false ;
        }

        if(isEmpty(user.username)){
            this.setState({
                usernameWarning:label.PleaseGenerateUsername
            })
            valid = false ;
        }

        if(isEmpty(user.email)){
            this.setState({
                emailWarning:label.PleaseEnterEmail
            })
            valid = false ;
        }

        valid = await this.verifyEmail(user.id, this.state.user.email)

        if(!userRole || !userRole.id){
            this.setState({
                userRoleWarning:label.PleaseSelectRoleForThisUser
            })
            valid = false ;
        }

        if(!manufacturingSite || !manufacturingSite.id){
            this.setState({
                manufacturingSiteWarning:label.PleaseSelectManufacturingSite
            })
            valid = false ;
        }

        if(isEmpty(user.mobilePhone) || user.mobilePhone.length<11){
            this.setState({
                mobilePhoneWarning:label.PleaseEnterARightMobilePhone
            })
            valid = false ;
        }

        if(valid){
            this.openConfirmDialog(label.Confirmation, (user.id?label.DoYouWantToUpdateInformationOfThisUser:label.DoYouWantToCreateANewUser), ()=>{
                this.saveUpload()
            })
        }
    }

    async saveUpload(){
        let photoBlob = this.state.photoBlob
        if(photoBlob){
            photoBlob = await new Promise(resolve => {
                axios({
                    url: photoBlob,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    this.closeProgress()
                    var file = response.data ;
                    resolve(file)
                })
            })
        }
        let user = this.state.user
        user.photoUrl = null
        var formData = new FormData();
        formData.append("userDtoGson", JSON.stringify(user))
        if(photoBlob){
            formData.append("photoMultipartFile", photoBlob);
        }
        this.post(Global.API.USER_SAVE_UPLOAD, formData, null, res=>{
            this.setState({
                user:res.data,
                userIdQuery:res.data.id
            }, () => {
                this.openSuccessDialog(label.Success, label.SuccessUpdatingData, ()=>{
                    this.props.history.goBack();
                })
            })
        },  true, true)

    }


    generateUsername(){
        let user = this.state.user
        if(isEmpty(user.email)){
            this.errorToast(label.PleaseEnterEmailToGenerateUsername)
            return
        }
        let params = {email:user.email}
        this.get(Endpoint.API.USER_GENERATE_USERNAME, {params}, null, response=>{
            if(response.code===200){
                let username = response.data
                user.username = username
                this.setState({
                    usernameWarning:"",
                    user:user
                })
            }

        }, true, true)
    }

    fetchUserDetail = (id) => {
        if(id!=null){
            this.get(Global.API.USER, {
                params :{
                    id : id
                }
            }, null, res=>{
                if(res.code===200){
                    let user = res.data;
                    let gender = null
                    GENDERS.forEach(value => {
                        if(value.key===user.gender){
                            gender = value ;
                        }
                    })
                    let userStatus = null
                    USER_STATUSES.forEach(value => {
                        if(value.name===user.userStatus){
                            userStatus = value ;
                        }
                    })

                    this.setState({
                        user:user,
                        userRole:user.userRole,
                        manufacturingSite:user.manufacturingSite,
                        userStatus:userStatus,
                        gender:gender,
                        bank:user.bank,
                        village:user.village?user.village:null,
                        district:user.village?user.village.district:null,
                        city:user.village?user.village.district.city:null,
                        province:user.village?user.village.district.city.province:null,
                    }, () => {
                        if(user.id){
                            this.fetchUserDevices()
                        }
                        if(this.state.village){
                            this.fetchCities(this.state.province.id, cities=>{
                                this.setState({
                                    cities:cities
                                })
                            })
                        }
                        if(this.state.city){
                            this.fetchDistricts(this.state.city.id, districts =>{
                                this.setState({
                                    districts:districts
                                })
                            })
                        }
                        if(this.state.district){
                            this.fetchVillages(this.state.district.id, villages=>{
                                this.setState({
                                    villages:villages
                                })
                            })
                        }

                    })
                }else{
                    this.props.history.goBack();
                }
            }, true, true);
        }
    }

    fetchUserDevices = () => {
        let user = this.state.user ;
        this.get(Global.API.USER_DEVICES, {
            params:{
                ascending:this.state.deviceAscending,
                sortir:this.state.deviceSortir,
                search:this.state.deviceSearch,
                userId:user.id,
            }
        }, null, res=>{
            if(res.code === 200){
                this.setState({
                    userDevices : res.data,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }, true, true);
    }

    fetchBanks = () => {
        this.get(Global.API.BANKS, {
            params:{
                ascending:this.state.ascending,
                sortir:this.state.sortir
            }
        }, null, response=>{
            if(response.code === 200){
                this.setState({
                    banks : response.data
                })
            }
        }, true, true);
    }

    fetchAllRole = () =>{
        kitchen.get(Global.API.USER_ROLES).then(res =>{
            if(res.data.code === 200){
                this.setState({
                    userRoles : res.data.data
                })
            }
        });
    }
    fetchManufacturingSites = () =>{
        this.get(Global.API.MANUFACTURING_SITES, {
            params:{
                ascending:this.state.ascending,
                sortir:this.state.sortir
            }
        }, null, response=>{
            if(response.code === 200){
                this.setState({
                    manufacturingSites : response.data
                })
            }
        }, true, true);
    }


    async verifyEmail(id, email){
        let {user} = this.state
        let response = await this.asyncGet(Global.API.USER_VALIDATE_EMAIL, {
            params:{
                id:user.id,
                email:email
            }
        }, null, false, false)

        if(response.code!=200){
            this.setState({
                emailWarning:response.message
            })
            return false ;
        }
        return true

    }

    refreshTransaction = (ascending, sortir) => (
        this.setState({
            ascending:ascending,
            sortir:sortir,
        }, () => {
        })
    )


    openCropper(image, cropperCallback, cancelCallback){
        this.setState({
            image:image,
            imageCropperModal:true,
            cropperCallback:cropperCallback,
            cancelCallback:cancelCallback
        })
    }

    render() {
        let imageAspect = 4/4
        let userStatusModal = this.state.userStatusModal
        let user = this.state.user?this.state.user:{}
        let userDevices = this.state.userDevices?this.state.userDevices:[]
        let gender = this.state.gender?this.state.gender:{}
        let injectBalanceModalMode = this.state.injectBalanceModalMode?this.state.injectBalanceModalMode:false

        let userStatusColor = user.userStatus&&user.userStatus===USER_STATUSES[0].name?"green":"#d80718"

        let canOpenMap = false ;
        //https://www.google.com/maps/dir/33.93729,-106.85761/33.91629,-106.866761/33.98729,-106.85861
        let url = "https://www.google.com/maps/dir"
        if(user.deviceCount>0 && userDevices.length>0){
            userDevices.map((item, index)=>{
                if(item.latitude && item.longitude){
                    canOpenMap = true
                    url = url+"/"+item.latitude+","+item.longitude
                }
                return item ;
            })
        }
        let evenOdd = 1 ;

        return (
            <Page
                title={label.UserDetail}
                breadcrumbs={[{ name: label.UserDetail, active: true }]}>
                {super.render()}
                <UpdateUserStatusModal
                    user={user} modal={this.state.updateUserStatusModal}
                    closeCallback={()=>{
                        this.setState({
                            updateUserStatusModal:false
                        })
                    }}
                    okCallback={()=>{
                        this.setState({
                            updateUserStatusModal:false
                        }, () => {
                            this.fetchUserDetail(user.id)
                        })
                    }}/>
                <UserStatusHistoryModal
                    showing={userStatusModal}
                    onClose={()=>{
                        this.setState({userStatusModal:false})
                    }}
                    user={user}/>
                <Row key={1}>
                    <Col>
                        <Card>
                            <PrimaryCardHeader
                                content={(
                                    <React.Fragment>
                                        <strong>{label.UserDetail}</strong>
                                        <ButtonGroup className="float-right">
                                            {
                                                user.id&&(
                                                    <>
                                                        <Button
                                                            color="danger"
                                                            onClick={(e)=>{
                                                                e.preventDefault()
                                                                this.openConfirmDialog(label.ResendPassword, label.DoYouWantToResendAPasswordForThisUser, async ()=>{
                                                                    let response = await this.asyncGet(Global.API.USER_RESEND_PASSWORD, {params:{userId:user.id}},
                                                                        false, true, false)
                                                                    if(response.code===200){
                                                                        this.openSuccessDialog(label.Success, label.SuccessSendingThePassword)
                                                                    }else{
                                                                        this.openFailedDialog(label.Failed, response.message)
                                                                    }
                                                                })
                                                            }}
                                                        >
                                                            {label.ResendPassword}&nbsp;<MdSecurity/>
                                                        </Button>
                                                        &nbsp;&nbsp;
                                                    </>
                                                )
                                            }
                                            <Button color="primary" onClick={async (e)=>{
                                                e.preventDefault()
                                                await this.confirmSave()
                                            }}>
                                                {
                                                    (this.state.user!=null && this.state.user.id!=null)?label.Update:label.Create
                                                }
                                                &nbsp;
                                                <MdSave/>
                                            </Button>
                                        </ButtonGroup>
                                    </React.Fragment>
                                )}/>
                            <CardBody>
                                <Row>
                                    <Col md={4}>
                                        <Card>
                                            <PrimaryCardHeader content={label.UserPhoto}/>
                                            <CardBody>
                                                <MyCardImage top src={
                                                    user.photoUrl!=null?user.photoUrl:userProfilePicture}
                                                         onClick={e=>{
                                                             if(!allIsEmpty(this.state.user, this.state.user.id)) {
                                                                 this.openLightBoxSingleImage(user.photoUrl)
                                                             }
                                                         }}
                                                         onError={(elm)=>this.defaultImage(elm, userProfilePicture)}/>
                                            </CardBody>
                                            <CardBody style={{verticalAlign:'text-center'}}>
                                                <Row>
                                                    <Col>
                                                        <ButtonGroup className="float-left">
                                                            <Button color="danger" onClick={e => {
                                                                user.photoUrl = null
                                                                this.setState({
                                                                    user:user
                                                                })
                                                            }}>{label.Cancel}</Button>
                                                        </ButtonGroup>
                                                    </Col>
                                                    <Col>
                                                        <ButtonGroup className="float-right">
                                                            <Button color="primary" onClick={e=>{
                                                                imageSelector(file =>{
                                                                    this.openCropper(file, (blob)=>{
                                                                        user.photoUrl = blob
                                                                        this.setState({
                                                                            photoBlob:blob,
                                                                            user:user
                                                                        })
                                                                    },  () =>{
                                                                        this.setState({
                                                                            photoBlob:null,
                                                                        })
                                                                    })
                                                                }).click()
                                                            }}>{label.Upload}</Button>
                                                        </ButtonGroup>
                                                    </Col>
                                                </Row>
                                                {
                                                    user.id&&(
                                                        <>
                                                            <br/>
                                                            <Row>
                                                                <Col>
                                                                    <Button
                                                                        style={{width:'100%', background:userStatusColor}}
                                                                        onClick={event => {
                                                                            this.setState({
                                                                                updateUserStatusModal:true
                                                                            })
                                                                        }}>
                                                                        {!user.userStatus?USER_STATUSES[1].name:user.userStatus}
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )
                                                }
                                                {
                                                    user.id&&(
                                                        <>
                                                            <Row>
                                                                <Col>
                                                                    <Button
                                                                        block
                                                                        color={"primary"}
                                                                        onClick={event => {
                                                                            this.setState({
                                                                                userStatusModal:true
                                                                            })
                                                                        }}>
                                                                        {label.StatusHistory}
                                                                        &nbsp;&nbsp;<MdHistory/>
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )
                                                }
                                                <br/>
                                                <Row style={{backgroundColor:(++evenOdd%2>0?'#d5d5d5':""), margin:'auto', padding:'8px'}}>
                                                    <Col md={5} style={{margin:'auto'}}>
                                                        {label.RegisteredOn}
                                                    </Col>
                                                    <Col md={1} style={{margin:'auto'}}>
                                                        :
                                                    </Col>
                                                    <Col md={6} style={{margin:'auto'}}>
                                                        {user.created?parseDate(user.created, DD_MM_YYYY_HH_MM_SS):"-"}
                                                    </Col>
                                                </Row>
                                                <Row style={{backgroundColor:(++evenOdd%2>0?'#d5d5d5':""), margin:'auto', padding:'8px'}}>
                                                    <Col md={5} style={{margin:'auto'}}>
                                                        {label.EverLoggedIn}
                                                    </Col>
                                                    <Col md={1} style={{margin:'auto'}}>
                                                        :
                                                    </Col>
                                                    <Col md={6} style={{margin:'auto'}}>
                                                        {
                                                            !user.firstLogin?(<span style={{color:'green'}}>{label.Yes}</span>):(<span style={{color:'red'}}>{label.Never}</span>)
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row style={{backgroundColor:(++evenOdd%2>0?'#d5d5d5':""), margin:'auto', padding:'8px'}}>
                                                    <Col md={5} style={{margin:'auto'}}>
                                                        {label.LastOpen}
                                                    </Col>
                                                    <Col md={1} style={{margin:'auto'}}>
                                                        :
                                                    </Col>
                                                    <Col md={6} style={{margin:'auto'}}>
                                                        {user.lastOpenDate?parseDate(user.lastOpenDate, DD_MM_YYYY_HH_MM_SS):"-"}
                                                    </Col>
                                                </Row>

                                                {
                                                    user.inspectionStatusCount&&(
                                                        Object.keys(user.inspectionStatusCount).map((key, index)=>(
                                                            <Row  style={{backgroundColor:((++evenOdd)%2>0?'#d5d5d5':""), margin:'auto', padding:'8px'}}>
                                                                <Col md={5} style={{margin:'auto'}}>
                                                                    {key}
                                                                </Col>
                                                                <Col md={1} style={{margin:'auto'}}>
                                                                    :
                                                                </Col>
                                                                <Col md={6} style={{margin:'auto'}}>
                                                                    {user.inspectionStatusCount[key]}
                                                                </Col>
                                                            </Row>
                                                        ))
                                                    )
                                                }
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={8}>
                                        <Card>
                                            <PrimaryCardHeader content={label.Profile}/>
                                            <CardBody>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label for="firstname">{label.Firstname}</Label>
                                                            <Input
                                                                type="text"
                                                                name="firstname"
                                                                className="text-capitalize"
                                                                value={(this.state.user!=null && this.state.user.firstname)?this.state.user.firstname:""}
                                                                onChange={(e) =>{
                                                                    let firstname = e.target.value
                                                                    user.firstname = firstname
                                                                    this.setState({
                                                                        fistNameWarning:"",
                                                                        user:user
                                                                    })
                                                                }}
                                                                placeholder={label.EnterFirstname}
                                                            />
                                                            <WarningLabel message={this.state.fistNameWarning} show={!isEmpty(this.state.fistNameWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label for="lastname">{label.Lastname}</Label>
                                                            <Input
                                                                type="text"
                                                                name="lastname"
                                                                className="text-capitalize"

                                                                value={(this.state.user!=null && this.state.user.lastname)?this.state.user.lastname:""}
                                                                onChange={(e) =>{
                                                                    let user = this.state.user
                                                                    if(user!=null){
                                                                        user.lastname = e.target.value
                                                                        this.setState({
                                                                            lastNameWarning:"",
                                                                            user:user
                                                                        })
                                                                    }
                                                                }}
                                                                placeholder={label.EnterLastname}
                                                            />
                                                            <WarningLabel message={this.state.lastNameWarning} show={!isEmpty(this.state.lastNameWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <Label for="username">{label.Username}</Label>
                                                            <Input
                                                                type="text"
                                                                name="username"
                                                                value={user.username}
                                                                disabled={true}
                                                                onChange={(e) =>{
                                                                    let user = this.state.user
                                                                    if(user!=null){
                                                                        user.username = e.target.value
                                                                        this.setState({
                                                                            usernameWarning:"",
                                                                            user:user
                                                                        })
                                                                    }
                                                                }}
                                                                placeholder={label.ClickButtonToGenerate}
                                                            />
                                                            <WarningLabel message={this.state.usernameWarning} show={!isEmpty(this.state.usernameWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="postalCode">&nbsp;</Label>
                                                            <br/>
                                                            <Button
                                                                color="primary"
                                                                block
                                                                onClick={event => {
                                                                    this.generateUsername()
                                                                }}>{
                                                                user.userCode?label.Regenerate:label.Generate
                                                            }</Button>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup>
                                                            <Label for="email">{label.Email}</Label>
                                                            <Input
                                                                type="text"
                                                                name="email"
                                                                value={user.email}
                                                                onChange={(e) =>{
                                                                    let email = e.target.value
                                                                    let user = this.state.user
                                                                    user.email = email
                                                                    this.setState({
                                                                        emailWarning:"",
                                                                        user:user
                                                                    })
                                                                    if(!isValidEmail(email)){
                                                                        this.setState({
                                                                            emailWarning:label.InvalidEmailAddress
                                                                        })
                                                                    }else{
                                                                        this.setState({
                                                                            emailWarning:undefined
                                                                        }, async () => {
                                                                            let valid = await this.verifyEmail(user.id, this.state.user.email)
                                                                        })
                                                                    }
                                                                }}
                                                                placeholder={label.EnterEmail}
                                                            />
                                                            <WarningLabel message={this.state.emailWarning} show={!isEmpty(this.state.emailWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.Role}
                                                                objects={this.state.userRoles}
                                                                default={this.state.userRole!=null?this.state.userRole.id:null}
                                                                noTranslation={true}
                                                                callback={(role)=>{
                                                                    if(user){
                                                                        user.userRole = role
                                                                        this.setState({
                                                                            userRoleWarning:"",
                                                                            user:user,
                                                                            userRole:role
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                            <WarningLabel message={this.state.userRoleWarning} show={!isEmpty(this.state.userRoleWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.ManufacturingSite}
                                                                objects={this.state.manufacturingSites}
                                                                default={this.state.manufacturingSite!=null?this.state.manufacturingSite.id:null}
                                                                noTranslation={true}
                                                                callback={(manufacturingSite)=>{
                                                                    if(user){
                                                                        user.manufacturingSite = manufacturingSite
                                                                        this.setState({
                                                                            manufacturingSiteWarning:"",
                                                                            user:user,
                                                                            manufacturingSite:manufacturingSite
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                            <WarningLabel message={this.state.manufacturingSiteWarning} show={!isEmpty(this.state.manufacturingSiteWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label for="mobilePhone">{label.MobilePhone}</Label>
                                                            <Input type="text"
                                                                   className="form-control"
                                                                   value={user.mobilePhone}
                                                                   pattern={"[0-9]*"}
                                                                   onChange={(e)=>{
                                                                       let mobilePhone = e.target.value
                                                                       let user = this.state.user
                                                                       if(user!=null && mobilePhone!=null){
                                                                           user.mobilePhone = cleanPhoneNumber(mobilePhone)
                                                                           this.setState({
                                                                               mobilePhoneWarning:"",
                                                                               user:user
                                                                           })
                                                                       }
                                                                   }}
                                                                   placeholder={label.EnterMobilePhone}/>
                                                            <WarningLabel message={this.state.mobilePhoneWarning} show={!isEmpty(this.state.mobilePhoneWarning)}/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label for="phoneNumber">{label.Phone}</Label>
                                                            <Input type="text"
                                                                   className="form-control"
                                                                   value={user.homePhoneNumber}
                                                                   pattern={"[0-9]*"}
                                                                   onChange={(e)=>{
                                                                       let homePhoneNumber = e.target.value
                                                                       let user = this.state.user
                                                                       if(user!=null && homePhoneNumber!=null){
                                                                           user.homePhoneNumber = cleanPhoneNumber(homePhoneNumber)
                                                                           this.setState({
                                                                               user:user
                                                                           })
                                                                       }
                                                                   }}
                                                                   placeholder={label.EnterPhoneNumber}/>
                                                            <FormText className={"font-italic"}><span style={{color:'red'}}>{this.state.phoneNumberWarning}</span></FormText>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <Label for="birthdate">{label.BirthDate}</Label>
                                                            <DateInput
                                                                id="birthdate"
                                                                maxdate={new Date()}
                                                                value={user.birthdate}
                                                                onChange={(e) =>{
                                                                    let value = e.target.value
                                                                    user.birthdate = value
                                                                    this.setState({
                                                                        user:user
                                                                    })
                                                                }}
                                                                placeholder={label.EnterBirthDate}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.Gender}
                                                                objects={GENDERS}
                                                                default={gender.id?gender.id:null}
                                                                callback={(gender)=>{
                                                                    user.gender = gender.key
                                                                    this.setState({
                                                                        user:user,
                                                                        gender:gender
                                                                    })
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <br/>
                                        <Card>
                                            <PrimaryCardHeader content={label.Address}/>
                                            <CardBody>
                                                <Row>
                                                    <Col md={9}>
                                                        <FormGroup>
                                                            <Label for="address">{label.Address}</Label>
                                                            <Input
                                                                type="text"
                                                                name="address"
                                                                className="text-capitalize"
                                                                value={user.address}
                                                                onChange={(e) =>{
                                                                    let user = this.state.user
                                                                    if(user!=null){
                                                                        user.address = e.target.value
                                                                        this.setState({
                                                                            user:user
                                                                        })
                                                                    }
                                                                }}
                                                                placeholder={label.EnterAddress}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="postalCode">{label.PostalCode}</Label>
                                                            <Input
                                                                type="text"
                                                                name="postalCode"
                                                                disabled={true}
                                                                value={(this.state.user!=null && this.state.user.village)?this.state.user.village.postalCode:""}
                                                                placeholder={label.PostalCode}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.SelectProvince}
                                                                objects={this.state.provinces}
                                                                default={!allIsEmpty(this.state.province)?this.state.province.id:null}
                                                                noTranslation={true}
                                                                callback={(province)=>{
                                                                    if(province!=null){
                                                                        this.setState({
                                                                            province:province,
                                                                            cities:[],
                                                                            districts:[],
                                                                            villages:[],
                                                                        }, () => {
                                                                            this.fetchCities(province.id, cities=>{
                                                                                this.setState({
                                                                                    cities:cities
                                                                                })
                                                                            })
                                                                        })
                                                                    }else{
                                                                        this.setState({
                                                                            province:null,
                                                                            cities:[],
                                                                            districts:[],
                                                                            villages:[],
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.SelectCity}
                                                                objects={this.state.cities}
                                                                default={!allIsEmpty(this.state.city)?this.state.city.id:null}
                                                                noTranslation={true}
                                                                callback={(city)=>{
                                                                    if(city!=null){
                                                                        this.setState({
                                                                            city:city,
                                                                            districts:[],
                                                                            villages:[],
                                                                        }, () => {
                                                                            this.fetchDistricts(city.id, districts =>{
                                                                                this.setState({
                                                                                    districts:districts
                                                                                })
                                                                            })
                                                                        })
                                                                    }else{
                                                                        this.setState({
                                                                            city:null,
                                                                            districts:[],
                                                                            villages:[],
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.SelectDistrict}
                                                                objects={this.state.districts}
                                                                default={!allIsEmpty(this.state.district)?this.state.district.id:null}
                                                                noTranslation={true}
                                                                callback={(district)=>{
                                                                    if(district!=null){
                                                                        this.setState({
                                                                            district:district,
                                                                            villages:[],
                                                                        }, () => {
                                                                            this.fetchVillages(district.id, villages=>{
                                                                                this.setState({
                                                                                    villages:villages
                                                                                })
                                                                            })
                                                                        })
                                                                    }else{
                                                                        this.setState({
                                                                            district:null,
                                                                            villages:[],
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col>
                                                        <FormGroup>
                                                            <ItemOption
                                                                title={label.SelectVillage}
                                                                objects={this.state.villages}
                                                                default={!allIsEmpty(this.state.village)?this.state.village.id:null}
                                                                noTranslation={true}
                                                                callback={(village)=>{
                                                                    if(village!=null){
                                                                        let user = this.state.user
                                                                        user.village = village
                                                                        this.setState({
                                                                            user:user,
                                                                            village:village,
                                                                        })
                                                                    }
                                                                }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {
                    !isEmpty(user.id)?
                        this.renderDevice()
                        :
                        null
                }
                <ImageCropper src={this.state.image} aspect={imageAspect} show={this.state.imageCropperModal} callback={file=>{
                    axios({
                        url: file,
                        method: 'GET',
                        responseType: 'blob', // important
                    }).then((response) => {
                        var fileBlob = response.data ;
                        let cropperCallback = this.state.cropperCallback
                        this.setState({
                            image:file,
                            imageCropperModal:false,
                        })
                        if(cropperCallback){
                            cropperCallback(file)
                        }
                    })
                }} cancelCallback={()=>{
                    this.setState({
                        image:null,
                        imageCropperModal:false,
                    })
                    let cancelCallback = this.state.cancelCallback
                    if(cancelCallback){
                        cancelCallback()
                    }
                }}/>

            </Page>

        );
    }

    refreshUserDevice = (ascending, sortir, progressing) => (
        this.setState({
            deviceAscending:ascending,
            deviceSortir:sortir
        }, () => {
            this.fetchUserDevices()
        })
    )

    renderDevice = () =>{
        var i = 0 ;
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection(
            {name:label.Created, field:'ud.created'},
            {name:label.Updated, field:'ud.updated'}
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})
        return (
            <>
                <Card className="mb-6">
                    <CardHeader>
                        <strong>{label.Devices}</strong>
                        <br/><br/>
                        <Row>
                            <Col md={6}>
                                <ButtonGroup className="d-flex w-100">
                                    <DropdownInput
                                        title={label.SortBy}
                                        options={orderOptions}
                                        onSelect={(item) => {
                                            this.refreshUserDevice(ascending, item.field, true)
                                        }}
                                        onReset={() => {
                                            this.refreshUserDevice(ascending, "ud.created", true)
                                        }}/>
                                    &nbsp;&nbsp;&nbsp;
                                    <DropdownInput
                                        options={ascendingOptions}
                                        onSelect={(item) => {
                                            this.refreshUserDevice(item.field, sortir, true)
                                        }}
                                        onReset={() => {
                                            this.refreshUserDevice(true, sortir, true)
                                        }}/>
                                </ButtonGroup>
                            </Col>
                            <Col md={6}>
                                <SearchInput
                                    placeholder={label.SearchDeviceId}
                                    value={this.state.search}
                                    onChange={e=>{
                                        this.setState({
                                            search:e.target.value
                                        }, () => {
                                            if(this.state.search===''){
                                                deleteParam(this.props, 'page')
                                            }
                                        })
                                    }}
                                    onEnter={e=>{
                                        if(this.state.search!==''){
                                            deleteParam(this.props, 'page')
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Table responsive hover>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{label.Platform}</th>
                                    <th>{label.IPAddress}</th>
                                    <th style={{width:'25%'}}>{label.UserAgent}</th>
                                    <th>{label.DeviceId}</th>
                                    <th>{label.Created}</th>
                                    <th>{label.LastOpen}</th>
                                    <th>{label.Delete}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.userDevices&&this.state.userDevices.map((item, index)=>(
                                        <tr key={item.id}>
                                            <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                            <td>{item.platform}</td>
                                            <td>{item.ipAddress}</td>
                                            <td>{item.userAgent}</td>
                                            <td>{item.deviceId}</td>
                                            <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                            <td>{parseDate(item.lastOpenDate, DD_MM_YYYY_HH_MM_SS)}</td>
                                            <td>
                                                <Button size="sm" color="danger" onClick={e => {
                                                    e.preventDefault()
                                                    this.setState({
                                                        userDevice:item
                                                    }, () => {
                                                        this.openConfirmDialog(label.DeleteConfirmationTitle, label.BanThisDevice_TheUserWillBeBannedAfterThisPerform,()=>{
                                                            this.get(Global.API.USER_DEVICE_DELETE+"/"+this.state.userDevice.id, null, null, res => {
                                                                if(res.code===200){
                                                                    this.successToast(res.message)
                                                                    this.fetchUserDevices()
                                                                }
                                                            }, true, true);

                                                        })
                                                    })
                                                }}>
                                                    <MdDelete/>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </Table>
                        </Row>
                    </CardBody>
                </Card>
                <br/>
            </>
        );
    }
}

export default Object.assign(UserDetailPage, {ENDPOINT : "/userDetail"})

